import { absolutePath } from "./absolutePath";

export const chatPreferences = {
  index: ({ params = {} } = {}) =>
    absolutePath("admin/chat_preferences", params),
  update: ({ params = {} } = {}) =>
    absolutePath("admin/chat_preferences", params),
};
